module.exports = __webpack_public_path__ + "342d7451f8b3006eafd4ac98cd8a83c2.woff";